import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

class Header extends Component {
    render() {
        let mobileMenu = classnames('header__menu', {
                'is-active': this.props.mobileNavActive
            }),
            mobileSearch = classnames('header__search', {
                'is-active': this.props.mobileSearchActive
            });

        return (
            <header className="header">
                <Link className="header__logo" to="/">
                    <svg className="icon icon-logo">
                        <use xlinkHref="#icon-logo" />
                    </svg>
                    <span className="header__title">Event Management</span>
                </Link>
                <button
                    onClick={this.props.toggleMobileNav}
                    className={mobileMenu}
                >
                    <svg className="icon icon-menu">
                        <use xlinkHref="#icon-menu" />
                    </svg>
                </button>
                <button
                    onClick={this.props.toggleSearch}
                    className={mobileSearch}
                >
                    <svg className="icon icon-search">
                        <use xlinkHref="#icon-search" />
                    </svg>
                    <svg className="icon icon-close">
                        <use xlinkHref="#icon-close" />
                    </svg>
                </button>
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js